import dayjs from 'dayjs'

const WEEKDAYS = ['일', '월', '화', '수', '목', '금', '토']

/**
 * dayjs 객체 생성 (안전한 파싱)
 * @param {string|Date} date
 * @returns {dayjs.Dayjs}
 */
const toDayjs = (date) => {
  return dayjs(date)
}

/**
 * 요일명 반환
 * @param {string|Date} date
 * @returns {string} '일'|'월'|...|'토'
 */
export const getWeekday = (date) => {
  return WEEKDAYS[toDayjs(date).day()]
}

// =============================================================================
// 포맷 유형 1: YYYY-MM-DD
// =============================================================================
/**
 * @param {string|Date} date
 * @returns {string} e.g. '2025-08-29'
 */
export const formatYMD = (date) => {
  return toDayjs(date).format('YYYY-MM-DD')
}

// =============================================================================
// 포맷 유형 2: MM/DD(요일)
// =============================================================================
/**
 * @param {string|Date} date
 * @returns {string} e.g. '08/29(금)'
 */
export const formatMDWeekday = (date) => {
  const d = toDayjs(date)
  return d.format('M/D') + '(' + WEEKDAYS[d.day()] + ')'
}

// =============================================================================
// 포맷 유형 3: YYYY-MM-DD ~ YYYY-MM-DD
// =============================================================================
/**
 * @param {string|Date} startDate
 * @param {string|Date} endDate
 * @returns {string} e.g. '2025-08-29 ~ 2025-09-05'
 */
export const formatYMDRange = (startDate, endDate) => {
  return formatYMD(startDate) + ' ~ ' + formatYMD(endDate)
}

// =============================================================================
// 포맷 유형 4: M/D(요일) ~ M/D(요일)
// =============================================================================
/**
 * @param {string|Date} startDate
 * @param {string|Date} endDate
 * @returns {string} e.g. '8/29(금) ~ 9/5(금)'
 */
export const formatMDWeekdayRange = (startDate, endDate) => {
  const s = toDayjs(startDate)
  const e = toDayjs(endDate)
  const sStr = s.format('M/D') + '(' + WEEKDAYS[s.day()] + ')'
  const eStr = e.format('M/D') + '(' + WEEKDAYS[e.day()] + ')'
  return sStr + ' ~ ' + eStr
}

// =============================================================================
// 포맷 유형 5: YYYY-MM-DD HH:mm:ss
// =============================================================================
/**
 * @param {string|Date} date
 * @returns {string} e.g. '2025-08-29 14:30:00'
 */
export const formatYMDHms = (date) => {
  return toDayjs(date).format('YYYY-MM-DD HH:mm:ss')
}

// =============================================================================
// 포맷 유형 6: YYYY-MM-DD HH:mm
// =============================================================================
/**
 * @param {string|Date} date
 * @returns {string} e.g. '2025-08-29 14:30'
 */
export const formatYMDHm = (date) => {
  return toDayjs(date).format('YYYY-MM-DD HH:mm')
}

// =============================================================================
// 포맷 유형 7: MM/DD(요일) HH:mm:ss
// =============================================================================
/**
 * @param {string|Date} date
 * @returns {string} e.g. '08/29(금) 14:30:00'
 */
export const formatMDWeekdayHms = (date) => {
  const d = toDayjs(date)
  return d.format('M/D') + '(' + WEEKDAYS[d.day()] + ') ' + d.format('HH:mm:ss')
}
